import React, { useEffect } from "react";
import classNames from "classnames";
import { ApplicationOption } from "./applicationSelection.types.ts";
import "@/assets/styles/components/_application-selection.styles.scss";
import KocumYanimda from "@/assets/svg/kocum-yanimda.svg";
import SimdiAnladim from "@/assets/svg/simdi-anladim.svg";
import Cozucu from "@/assets/svg/cozucu.svg";
import firstImg from "@/assets/images/video-call.png";
import secondImg from "@/assets/images/school-girl.png";
import thirdImg from "@/assets/images/question-mark.png";

const applicationOptions: ApplicationOption[] = [
  {
    id: "COACH",
    title: "Koçum Yanımda",
    description:
      "Koçum Yanımda ile uzman psikologlarımızla rehberlik görüşmesi sağlayabilirsiniz. Motivasyon, verimli çalışma yöntemleri, ders çalışma programı oluşturmak gibi birçok konuda",
    icon: <img src={KocumYanimda} alt={"Kocum Yanimda Logo"} />,
    image: <img src={firstImg} alt={"Video Call"} />,
    selected: false,
  },
  {
    id: "GOT_IT",
    title: "Şimdi Anladım",
    description:
      "Koçum Yanımda ile uzman psikologlarımızla rehberlik görüşmesi sağlayabilirsiniz. Motivasyon, verimli çalışma yöntemleri, ders çalışma programı oluşturmak gibi birçok konuda",
    icon: <img src={SimdiAnladim} alt={"Şimdi Anladım Logo"} />,
    image: <img src={secondImg} alt={"Video Call"} />,
    selected: false,
  },
  {
    id: "SOLVER",
    title: "Çözücü",
    description:
      "Koçum Yanımda ile uzman psikologlarımızla rehberlik görüşmesi sağlayabilirsiniz. Motivasyon, verimli çalışma yöntemleri, ders çalışma programı oluşturmak gibi birçok konuda",
    icon: <img src={Cozucu} alt={"Çözücü Logo"} />,
    image: <img src={thirdImg} alt={"Video Call"} />,
    selected: true,
  },
];

export const ApplicationSelection: React.FC<{
  selectedOption: string;
  onOptionSelect: (optionId: string) => void;
  apiWithSelectedApp?: string;
  setSelectedOption: (id: string) => void;
}> = ({
  selectedOption,
  onOptionSelect,
  apiWithSelectedApp,
  setSelectedOption,
}) => {
  useEffect(() => {
    if (apiWithSelectedApp) {
      setSelectedOption(apiWithSelectedApp);
    }
  }, [apiWithSelectedApp]);

  return (
    <div className="section-content-application-selection">
      <div className="section-intro">
        <h3 className="content-title">Uygulama Seçimi</h3>
        {/* <p className="content-description">
          Viverra porta eget tortor maecenas elit sagittis ultrices dignissim
          non. In cursus neque ut ac id dictum.
        </p> */}
      </div>

      <div className="options-grid">
        {applicationOptions.map((option) => {
          const isSelected = selectedOption === option.id;

          return (
            <div
              key={option.id}
              className={classNames("option-card", {
                selected: isSelected,
              })}
              onClick={() => onOptionSelect(option?.id)}
            >
              <div className="title-wrapper">
                <div className="title-contain">
                  <div className={classNames("option-icon", option?.id)}>
                    {option?.icon}
                  </div>
                  <h4 className="option-title">{option?.title}</h4>
                </div>
                <div className="radio-button">
                  <div
                    className={classNames("radio-outer", {
                      selected: isSelected,
                    })}
                  >
                    {isSelected && <div className="radio-inner"></div>}
                  </div>
                </div>
              </div>
              <p className="option-description">{option?.description}</p>

              <div className="option-illustration">{option?.image}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
